var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.className }, [
    _vm._v("右上角“管理分类”可添加分类"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }